storeResult